import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { reportError } from 'app/shared/util/error-reporting';

/**
 * Redux middleware that intercepts RTK Query rejected-with-value actions and
 * forwards them to the error-reporting service.
 */
export const errorMiddleware: Middleware = () => next => action => {
  if (isRejectedWithValue(action)) {
    reportError((action as { error: unknown }).error, { action: JSON.stringify(action) });
  }
  return next(action);
};
